import React from 'react';
import { ExternalLink, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { REG_CTA } from '@/constants/testIds';
import { AAWTA } from '@/lib/aawta';

const openExternal = (url) => window.open(url, '_blank', 'noopener,noreferrer');

export const RegistrationCTA = () => {
  return (
    <section
      id="register"
      data-testid={REG_CTA.section}
      className="relative py-24 md:py-32 overflow-hidden bg-aawta-navy text-white"
    >
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-aawta-navy via-aawta-navy-deep to-aawta-navy" />
        <div className="absolute inset-0 bg-grid-navy opacity-25" />
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-aawta-magenta/25 blur-3xl" />
      </div>

      <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 backdrop-blur">
              <span className="w-1.5 h-1.5 rounded-full bg-aawta-magenta animate-pulse" />
              <span className="overline text-white/90">September 17, 2026 · Stone Mountain, GA</span>
            </div>
            <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl mt-6 tracking-tight leading-[1.05]">
              Ready to <span className="text-aawta-magenta">Join Us?</span>
            </h2>
            <div className="w-14 h-[3px] bg-aawta-magenta rounded-full mt-6" />
            <p className="mt-6 text-lg md:text-xl text-white/85 max-w-2xl leading-relaxed">
              Join transportation, logistics, workforce development, education, government,
              nonprofit, and industry leaders as we work together to build the future
              workforce.
            </p>

            <div className="mt-9 flex flex-wrap gap-3">
              <Button
                data-testid={REG_CTA.registerNow}
                onClick={() => openExternal(AAWTA.eventbriteUrl)}
                className="rounded-full bg-aawta-magenta hover:bg-aawta-magenta-hover text-white font-medium px-8 py-6 text-[15px] shadow-aawta-magenta hover:-translate-y-0.5 transition-all duration-200 group"
              >
                Register Now
                <ExternalLink className="ml-2 h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
              </Button>
              <Button
                data-testid={REG_CTA.becomeSponsor}
                onClick={() => openExternal(AAWTA.zeffySponsorUrl)}
                variant="outline"
                className="rounded-full bg-white text-aawta-navy hover:bg-white/90 border-white font-medium px-8 py-6 text-[15px] group"
              >
                Become a Sponsor
                <ExternalLink className="ml-2 h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
              </Button>
              <Button
                onClick={() => (window.location.href = '/volunteer')}
                data-testid="reg-cta-volunteer"
                variant="ghost"
                className="rounded-full bg-transparent text-white hover:bg-white/10 border border-white/30 hover:border-white/60 font-medium px-6 py-6 text-[15px]"
              >
                Apply to Volunteer
              </Button>
              <Button
                onClick={() => (window.location.href = '/media')}
                data-testid="reg-cta-media"
                variant="ghost"
                className="rounded-full bg-transparent text-white hover:bg-white/10 border border-white/30 hover:border-white/60 font-medium px-6 py-6 text-[15px]"
              >
                Apply for Media Credentials
              </Button>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-white/70 text-sm">
              <div className="flex items-center gap-2">
                <ArrowRight className="h-4 w-4 text-aawta-magenta" />
                Powered by Eventbrite &amp; Zeffy
              </div>
              <div className="flex items-center gap-2">
                <ArrowRight className="h-4 w-4 text-aawta-magenta" />
                100% of sponsor funds support workforce impact
              </div>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -inset-3 bg-aawta-magenta/25 blur-2xl rounded-3xl" />
              <div className="relative rounded-3xl overflow-hidden border-2 border-white/15 shadow-[0_30px_80px_rgba(0,0,0,0.4)]">
                <img
                  src={AAWTA.flyerUrl}
                  alt="AAWTA Summit event flyer"
                  className="w-full h-auto block"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegistrationCTA;
